// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_SUl","cls2":"ReportList-cls2_N9_ ReportList-cls1_SUl"};